export const DJANGO_API = 'https://petmimo-back-zzz477rgka-uc.a.run.app/api/v1';
//export const DJANGO_API = 'http://168.138.144.105:5000/api/v1/';

export const PAYPAL_GATEWAY = 'https://web-4b412.web.app/';

export const API_KEY = 'ycqqaI1T.NvF95nENcdwlEw631JQ3isRNgKU3cnR2';

export const FRONTEND_URL = 'https://petmimo.com/pet/';
//export const FRONTEND_URL = 'https://petmimo-website-zzz477rgka-uc.a.run.app/pet/';
